// Only these lab codes are considered valid for analysis:
// CON, CONCER, CONEUR, CONEURCER, and CONLAB.
export const isLabValidForAnalysis = (lab?: string | null): boolean => {
  if (!lab?.trim()) {
    return false;
  }

  return lab.trim().toUpperCase().startsWith("CON");
};